import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import * as actions from './actions'
import * as UserSelectors from 'modules/user/selectors'
import { api } from './api'

const createProfile = (action$, store) => {
  return action$
    .ofType(actions.createProfile.toString())
    .mergeMap(() => {
      const userId = UserSelectors.getUserId(store.getState())
      return api
        .createProfile(userId)
        .map(actions.createProfileSuccess)
        .startWith(actions.createProfilePending())
        .catch(() => Observable.of(actions.createProfileFailed()))
    })
}

const updateProfile = (action$, store) => {
  return action$
    .ofType(actions.updateProfile.toString())
    .pluck('payload')
    .mergeMap(operations => {
      const userId = UserSelectors.getUserId(store.getState())
      return api
        .updateProfile(userId, operations)
        .map(actions.updateProfileSuccess)
        .startWith(actions.updateProfilePending())
        .catch(() => Observable.of(actions.updateProfileFailed()))
    })
}

const fetchProfile = (action$, store) => {
  return action$
    .ofType(actions.fetchProfile.toString())
    .pluck('payload')
    .mergeMap(operations => {
      const userId = UserSelectors.getUserId(store.getState())
      return api
        .fetchProfile(userId)
        .map((res) => actions.fetchProfileSuccess(res.response))
        .startWith(actions.fetchProfilePending())
        .catch(() => Observable.of(actions.fetchProfileFailed()))
    })
}

const checkUniqueHandle = action$ => {
  return action$
    .ofType(actions.checkUniqueHandle.toString())
    .debounceTime(200)
    .pluck('payload')
    .mergeMap(handle => {
      return api
        .checkUniqueHandle(handle)
        .map(actions.checkUniqueHandleFailed)
        .catch(error => {
          if (error.status === 404) {
            return Observable.of(actions.checkUniqueHandleSuccess())
          }
          return Observable.of(actions.checkUniqueHandleFailed())
        })
    })
}

const uploadCoverPhoto = action$ => {
  return action$
    .ofType(actions.uploadCoverPhoto.toString())
    .pluck('payload')
    .switchMap(file => {
      return api
        .upload(file)
        .map(({ url }) => actions.uploadCoverPhotoSuccess(url))
        .startWith(actions.uploadCoverPhotoPending())
        .catch((err) => Observable.of(actions.uploadCoverPhotoFailed()))
    })
}

const initCalendarUserProfile = (action$, store) => {
  return action$
    .ofType(actions.createProfileSuccess.toString())
    .filter(() => UserSelectors.isCalendarSeatOnboarding(store.getState()))
    .mergeMap(() => {
      const userId = UserSelectors.getUserId(store.getState())
      return api
        .updateProfile(userId, [{
          operation: 'set',
          value: true,
          property: 'calendarOnlyStatus',
        }])
        .map(actions.updateProfileSuccess)
        .startWith(actions.updateProfilePending())
        .catch(() => Observable.of(actions.updateProfileFailed()))
    })
}

export const epic = combineEpics(
  createProfile,
  updateProfile,
  fetchProfile,
  checkUniqueHandle,
  uploadCoverPhoto,
  initCalendarUserProfile
)



// WEBPACK FOOTER //
// ./src/modules/profile/epic.js